/**
 * Stores the specified tooltip identifier in localStorage to mark it as hidden. Does not store empty strings.
 * @param toolTipId - The identifier of the tooltip to be marked as hidden.
 */
export const storeToolTipToHide = (toolTipId: string): void => {
  if (toolTipId.trim() === '') {
    return;
  }
  const hiddenToolTips: Set<string> = new Set(
    JSON.parse(localStorage.getItem('hidden-tooltips') || '[]')
  );
  hiddenToolTips.add(toolTipId);
  localStorage.setItem('hidden-tooltips', JSON.stringify(Array.from(hiddenToolTips)));
};

/**
 * Checks if the specified tooltip identifier is marked as hidden in localStorage.
 * @param toolTipId - The identifier of the tooltip to check.
 * @returns true if the tooltip is marked as hidden, false otherwise.
 */
export const isToolTipHidden = (toolTipId: string): boolean => {
  const hiddenToolTips: Array<string> = JSON.parse(localStorage.getItem('hidden-tooltips') || '[]');
  return hiddenToolTips.includes(toolTipId);
};
